import { apicall } from "../../services/api";

import {
	GET_CAMPAIGN,
	GET_CAMPAIGNS,
	ADD_CAMPAIGN,
	UPDATE_CAMPAIGN,
	REMOVE_CAMPAIGN,
	ERR_CAMPAIGN,
	LOADING_CAMPAIGNS,
} from "../actions/actionTypes";

export const getCampaign =
	(campaignId, cb = null) =>
	async (dispatch) => {
		try {
			let res = {
				data: {
					name: "",
					description: "",
					status: "Deactivated",
					banners: [],
					offerings: [],
				},
			};

			if (campaignId) {
				//const res = await api.get(`/campaign/${campaignId}`);
				dispatch(showLoading(true));
				res = await fetch(`https://dummyjson.com/products/${campaignId}`).then(
					(res) => res.json()
				);

				if (res.id) {
					res.data = {
						id: res.id,
						name: res.title,
						banners: res.images,
						description: res.description,
						status:
							Math.floor(Math.random() * 100) % 2 === 0
								? "Active"
								: "Deactivated",
					};
				} else {
					res.data = {
						name: "",
						description: "",
						status: "Deactivated",
						banners: [],
						offerings: [],
					};
				}
			}

			if (cb) cb();

			dispatch({
				type: GET_CAMPAIGN,
				payload: res.data,
			});
		} catch (err) {
			dispatch({
				type: ERR_CAMPAIGN,
				payload: {
					msg: err.response ? err.response.statusText : "",
					status: err.response ? err.response.status : "",
				},
			});
		}
	};

export const getAllCampaigns =
	(cb = null) =>
	async (dispatch) => {
		try {
			//const res = await api.get(`/campaign`);
			dispatch(showLoading(true));
			const res = await fetch("https://dummyjson.com/products").then((res) =>
				res.json()
			);

			res.data = res.products.map((item) => {
				return {
					id: item.id,
					name: item.title,
					banners: item.images,
					status:
						Math.floor(Math.random() * 100) % 2 === 0
							? "Active"
							: "Deactivated",
				};
			});

			dispatch({
				type: GET_CAMPAIGNS,
				payload: res.data,
			});

			if (cb) cb();
		} catch (err) {
			dispatch({
				type: ERR_CAMPAIGN,
				payload: { msg: err.response.statusText, status: err.response.status },
			});
		}
	};
export const updateCampaign = (campaignId, formData) => async (dispatch) => {
	try {
		dispatch(showLoading(true));
		const res = await apicall(`/campaign/${campaignId}`, "put", formData);

		dispatch({
			type: UPDATE_CAMPAIGN,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_CAMPAIGN,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
	}
};

export const createCampaign = (formData) => async (dispatch) => {
	try {
		dispatch(showLoading(true));
		const res = await apicall(
			"/campaign",
			{
				"Content-Type": "multipart/form-data",
				"Access-Control-Allow-Origin": "*",
			},
			"post",
			formData
		);

		dispatch({
			type: ADD_CAMPAIGN,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_CAMPAIGN,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
	}
};

export const deleteCampaign = (campaignId) => async (dispatch) => {
	if (window.confirm("Are you sure? This can NOT be undone!")) {
		try {
			await apicall(`/campaign/${campaignId}`, "delete");

			dispatch({ type: REMOVE_CAMPAIGN, payload: campaignId });
		} catch (err) {
			dispatch({
				type: ERR_CAMPAIGN,
				payload: { msg: err.response.statusText, status: err.response.status },
			});
		}
	}
};
export const showLoading = (flag) => async (dispatch) => {
	dispatch({
		type: LOADING_CAMPAIGNS,
		payload: flag,
	});
}